import { render, staticRenderFns } from "./TimelineYear.vue?vue&type=template&id=bbbf1ef4&scoped=true&"
import script from "./TimelineYear.vue?vue&type=script&lang=js&"
export * from "./TimelineYear.vue?vue&type=script&lang=js&"
import style0 from "./TimelineYear.vue?vue&type=style&index=0&id=bbbf1ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf1ef4",
  null
  
)

export default component.exports